import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { validateEventDetailSearch } from "@/features/events/routeSearch";
export const Route = createFileRoute("/events/$eventId")({
  component: lazyRouteComponent(
    () => import("@/pages/EventsPage"),
    "EventDetailPage",
  ),
  validateSearch: validateEventDetailSearch,
});
